import { RouteItem } from '@eastcoal/router/types/route'

import { RANKING_AUCTION_CREATE_PAGE_PATH } from '../constants/path'

export const rankingAuctionCreateRoute: RouteItem = {
  title: '新增竞拍（排名）',
  hideInMenu: true,
  path: RANKING_AUCTION_CREATE_PAGE_PATH,
  Component: () => import('./index')
}
